import { createFileRoute } from "@tanstack/react-router";
import IndexPage from "@/pages/Index";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { getContactSettings } from "@/lib/server-functions";
import { homeJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/")({
  // The homepage must still render if contact settings are unavailable.
  loader: async () => ({ contact: await getContactSettings().catch(() => null) }),
  head: ({ loaderData }) => {
    const pageUrl = getPageUrl("/");

    return {
      meta: [
        { title: "KNMC — Best Hospital in Kathmandu, Nepal" },
        {
          name: "description",
          content:
            "KNMC is a leading multi-speciality hospital in Kathmandu, Nepal. 24/7 emergency, 50+ expert doctors, modern facilities and online appointment booking.",
        },
        {
          name: "keywords",
          content:
            "best hospital in Kathmandu, hospital Nepal, KNMC Kathmandu, multi-speciality hospital Nepal, 24/7 emergency Kathmandu, teaching hospital Kathmandu",
        },
        {
          property: "og:title",
          content: "KNMC — Best Hospital in Kathmandu, Nepal",
        },
        {
          property: "og:description",
          content:
            "12+ specialities, 50+ expert doctors and 24/7 emergency care in Kathmandu. Book appointments online at Kathmandu National Medical College & Teaching Hospital.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        homeJsonLd(loaderData?.contact ?? null),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: IndexPage,
});